import { jsx as _jsx } from "react/jsx-runtime";
import { Radio as HeroRadio } from '@heroui/react';
export const Radio = ({ color, size, className, children, ...props }) => {
    return (_jsx(HeroRadio, { color: color, size: size, className: className, ...props, children: children }));
};
//# sourceMappingURL=Radio.js.map